import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import PopupForm from "./PopupForm";

export default function PopupManager() {
  const [showPopup, setShowPopup] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/admin")) {
      return;
    }

    const MAX_POPUP_SHOWS = 2; // Maximum 2 times per user
    const TIME_BETWEEN_POPUPS = 30; // Seconds between popups (adjust as needed)
    
    // Get current popup data
    const popupData = localStorage.getItem("popupData");
    let showCount = 0;
    let lastShowTime = null;

    if (popupData) {
      const parsed = JSON.parse(popupData);
      showCount = parsed.showCount || 0;
      lastShowTime = parsed.lastShowTime;
    }

    // If already shown MAX_POPUP_SHOWS times, don't show again
    if (showCount >= MAX_POPUP_SHOWS) {
      return;
    }

    // Check if enough time has passed since last show
    const canShowPopup = () => {
      if (!lastShowTime) return true;
      const lastTime = new Date(lastShowTime);
      const currentTime = new Date();
      const secondsDiff = (currentTime - lastTime) / 1000;
      return secondsDiff >= TIME_BETWEEN_POPUPS;
    };

    // Function to show popup
    const showPopupWithDelay = (delaySeconds = 5) => {
      setTimeout(() => {
        setShowPopup(true);
        
        // Update localStorage with new show count
        const currentData = localStorage.getItem("popupData");
        const parsed = currentData ? JSON.parse(currentData) : { showCount: 0 };
        const updatedData = {
          showCount: parsed.showCount + 1,
          lastShowTime: new Date().toISOString()
        };
        localStorage.setItem("popupData", JSON.stringify(updatedData));
      }, delaySeconds * 1000);
    };

    // Show first popup after 5 seconds
    if (showCount === 0 && canShowPopup()) {
      showPopupWithDelay(5);
    }
    // Show second popup after 30 seconds (or after first one is closed)
    else if (showCount === 1 && canShowPopup()) {
      showPopupWithDelay(TIME_BETWEEN_POPUPS);
    }

  }, [location.pathname]);

  const handleClosePopup = () => {
    setShowPopup(false);
    
    // After closing, check if we need to schedule the next popup
    const popupData = localStorage.getItem("popupData");
    if (popupData) {
      const parsed = JSON.parse(popupData);
      const TIME_BETWEEN_POPUPS = 30; // Seconds
      
      // If this was the first show (showCount = 1), schedule second popup
      if (parsed.showCount === 1) {
        setTimeout(() => {
          // Check again if we should show (in case user already submitted)
          const currentData = localStorage.getItem("popupData");
          const currentParsed = currentData ? JSON.parse(currentData) : { showCount: 1 };
          const popupSubmitted = localStorage.getItem("popupSubmitted");
          
          if (currentParsed.showCount < 2 && !popupSubmitted) {
            setShowPopup(true);
            const updatedData = {
              showCount: currentParsed.showCount + 1,
              lastShowTime: new Date().toISOString()
            };
            localStorage.setItem("popupData", JSON.stringify(updatedData));
          }
        }, TIME_BETWEEN_POPUPS * 1000);
      }
    }
  };

  if (!showPopup) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[100] flex items-center justify-center p-4 animate-in fade-in duration-200">
      <div className="animate-in zoom-in-95 duration-300">
        <PopupForm onClose={handleClosePopup} />
      </div>
    </div>
  );
}